import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Method from "./pages/Method";
import EnergyTherapy from "./pages/EnergyTherapy";
import Resources from "./pages/Resources";
import CareBnB from "./pages/CareBnB";
import HealthCoaching from "./pages/HealthCoaching";
import GiftCareBnB from "./pages/GiftCareBnB";
import Workshops from "./pages/Workshops";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import StickyQuizButton from "./components/StickyQuizButton";
import { Toaster } from "./components/ui/sonner";

// Keep the canonical link pointing at the current page, not always the homepage
const CanonicalLink = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const link = document.querySelector('link[rel="canonical"]');
    if (link) link.href = `https://momshiach.com${pathname}`;
    document.documentElement.classList.toggle("mh-not-home", pathname !== "/");
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/method" element={<Method />} />
          <Route path="/energy-therapy" element={<EnergyTherapy />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/carebnb" element={<CareBnB />} />
          <Route path="/health-coaching" element={<HealthCoaching />} />
          <Route path="/gift" element={<GiftCareBnB />} />
          <Route path="/workshops" element={<Workshops />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <CanonicalLink />
        <StickyQuizButton />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
